import { type ReactNode, useEffect, useRef } from 'react';
import { PlayerFrame } from './youtube-embed-parts';

const PLACEHOLDER_CLS =
  'flex aspect-video w-full items-center justify-center rounded-lg border border-white/[0.08] bg-white/[0.05] text-text-tertiary backdrop-blur-xl';

type Props = {
  videoId: string;
  onWatched?: () => void;
  threshold?: number;
  nativeControls?: boolean;
  onProgress?: (elapsed: number, duration: number) => void;
};

function isPlaceholderId(id: string): boolean {
  return !id || id === 'PLACEHOLDER';
}

function usePlaceholderAck(isPh: boolean, cb?: () => void): void {
  const fired = useRef(false);
  useEffect(() => {
    if (isPh && cb && !fired.current) {
      fired.current = true;
      cb();
    }
  }, [isPh, cb]);
}

export function YouTubeEmbed(props: Props): ReactNode {
  const { videoId, onWatched, threshold = 0.8 } = props;
  const isPh = isPlaceholderId(videoId);
  usePlaceholderAck(isPh, onWatched);
  if (isPh) return <div className={PLACEHOLDER_CLS}>Video no disponible</div>;
  return (
    <PlayerFrame
      videoId={videoId}
      threshold={threshold}
      onWatched={onWatched ?? ((): void => undefined)}
      nativeControls={props.nativeControls ?? false}
      {...(props.onProgress && { onProgress: props.onProgress })}
    />
  );
}
